'use client';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Title from '@/components/common/ui/text/Title';
import Button from '@/components/common/ui/buttons/Button';
import reactHtmlParser from 'react-html-parser';
import { StyledOverviewSimple } from '@/components/common/ygen/sections/overview-simple/overview-simple.style';

const OverviewSimple = ({ data, version }) => {

	return (
		<StyledOverviewSimple className={`${version ? 'version' : ''} OverviewFive`} data-scroll-section>

			<Container>
				<Row>
					<Col md={12}>
						<div className="header">
							{
								data?.section_data?.subtitle &&
								<p className={'subtitle-ygen fade-up'}>
									{data?.section_data?.subtitle}

								</p>
							}

						</div>
					</Col>
					<Col md={6}>
						{
							data?.section_data?.short_desc &&
							<Title tag={'h2'} animClass={'fade-up'} margin={'0 0 40px'} text={data?.section_data?.short_desc} color={'#000'} />

						}

						{
							data?.section_data?.description &&
							reactHtmlParser(data?.section_data?.description)
						}

						<Button background={'#152637'} margin={'40px 0 0'} color={'#152637'} pathColor={'white'} text={'Let’s Talk'} src={'/contact'} />

					</Col>
					<Col md={{ span: 5, offset: 1 }} className={'margin-top-60'}>
						<img src={data?.images?.list?.[0]?.full_path} alt={data?.section_data?.title} />

					</Col>
				</Row>
			</Container>
		</StyledOverviewSimple>
	);
};


export default React.memo(OverviewSimple);
